import { OnboardingConfigSchema, type OnboardingConfig } from './config-schema'
import { DEFAULT_ONBOARDING_CONFIG } from './default-config'

/**
 * The onboarding config the app runs on. Phase 1/2: the bundled snapshot.
 * Phase 3 swaps this to prefer the server-fetched admin-managed config, with
 * the bundle as the fallback; every consumer (flow, checklist card, signals,
 * tips) reads through here so that swap is a one-file change.
 */
const BUNDLED = OnboardingConfigSchema.parse(DEFAULT_ONBOARDING_CONFIG)

export function activeOnboardingConfig(): OnboardingConfig {
  return BUNDLED
}
